import React from 'react';
import MortgageForm from "../../../../../components/data-capture/MortgageForm";

function ApplicationForm({section, inExtWindow=true}) {

    return (
        <MortgageForm inExtWindow={inExtWindow} questions={[
            {
                label: "PPS Number",
                name: "ppsNumber",
                answer: {
                    type: "text",
                },
                target: `applicant${section.applicant}.tax.ppsNumber`,
            },
        ]}/>
    );
}

export default ApplicationForm;